import { useState } from "react";
import { Link } from "react-router-dom";
import { Flag, ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";

/* Data provenance strip + "Report an update" correction form (master plan §14/40). */
export const EntityTrustFooter = ({ entityType, entityId, entityName }) => {
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState("");
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (msg.trim().length < 10) { toast.error("Please describe the update (at least 10 characters)"); return; }
    setBusy(true);
    try {
      await api.post("/v1/corrections", {
        page_url: window.location.pathname, entity_type: entityType,
        entity_id: String(entityId || ""), entity_name: entityName,
        message: msg.trim(), email: email.trim() || null,
      });
      toast.success("Thank you — our editors will review your report.");
      setOpen(false); setMsg(""); setEmail("");
    } catch { toast.error("Could not submit — please try again."); }
    setBusy(false);
  };

  return (
    <div className="mt-10 border border-zinc-200 bg-zinc-50 p-4" data-testid="entity-trust-footer">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <p className="text-xs text-zinc-500 flex items-start gap-1.5 max-w-xl">
          <ShieldCheck className="w-3.5 h-3.5 mt-0.5 shrink-0 text-emerald-600" />
          <span>Entity data from open aviation datasets (OurAirports, OpenFlights) with AI-assisted editorial clearly marked. Always confirm time-sensitive details with the official {entityType} website. <Link to="/sources" className="text-blue-700 hover:underline font-700">Sources & verification</Link></span>
        </p>
        <button onClick={() => setOpen(!open)} data-testid="report-update-btn"
          className="inline-flex items-center gap-1.5 px-3 py-2 text-xs font-800 border border-zinc-300 bg-white hover:border-sky-700 transition-colors">
          <Flag className="w-3.5 h-3.5" /> Report an update
        </button>
      </div>
      {open && (
        <div className="mt-3 space-y-2" data-testid="report-update-form">
          <textarea value={msg} onChange={(e) => setMsg(e.target.value)} rows={3} maxLength={2000}
            placeholder={`What's outdated or wrong on this ${entityType} page? Include a source link if you can.`}
            data-testid="report-update-message"
            className="w-full border border-zinc-300 p-2.5 text-sm outline-none focus:ring-2 focus:ring-sky-700" />
          <div className="flex flex-wrap gap-2">
            <input value={email} onChange={(e) => setEmail(e.target.value)} type="email" placeholder="Email (optional)"
              data-testid="report-update-email"
              className="border border-zinc-300 px-3 py-2 text-sm w-64 outline-none focus:ring-2 focus:ring-sky-700" />
            <button onClick={submit} disabled={busy} data-testid="report-update-submit"
              className="px-4 py-2 text-sm font-800 bg-sky-800 text-white hover:bg-sky-900 disabled:opacity-50 transition-colors">
              {busy ? "Sending…" : "Send to editors"}
            </button>
          </div>
          <p className="text-[11px] text-zinc-400">Reports go to a human review queue — nothing is auto-published. See our <Link to="/corrections-policy" className="underline">corrections policy</Link>.</p>
        </div>
      )}
    </div>
  );
};
